<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="isCreateMode ? 'ADD TAX CODE' : 'UPDATE TAX CODE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-carrier-popup" @submit.prevent="handleSubmit(onClickCreateCarrier)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="code" name="code" rules="required" v-slot="{ errors }">
                <small class="label">Tax code</small>
                <vs-input v-model="form.code"  name="code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="percent" name="percent" rules="required" v-slot="{ errors }">
                <small class="label">Percentage (%)</small>
                <vs-input v-model="form.percent"  name="percent" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-tax-codes-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const CarrierRepository = RepositoryFactory.get('carrier');
  const TaxRepository = RepositoryFactory.get('tax');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: ''
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'CreateCarrierPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(data) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!data) {
            this.id = data.id
            this.form = data
            this.isCreateMode = false
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchCarrierDetails() {
        await this.$vs.loading({
          container: '#create-carrier-popup',
          scale: 0.45
        })
        try {
          const {data} = (await CarrierRepository.getCarrier(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
      },
      async onClickCreateCarrier() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-carrier-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            this.form.percent = Number(this.form.percent).toFixed(2)
            await TaxRepository.createTaxCode(this.form);
            this.showSuccessMessage('Tax code added successfully');
          } else {
            this.form.percent = Number(this.form.percent).toFixed(2)
            await TaxRepository.updateTaxCode(this.id, this.form);
            this.showSuccessMessage('Tax code updated successfully');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-carrier >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
